module.exports = __webpack_public_path__ + "static/img/icon_hccx.62cf9f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_hccx.png
// module id = j8vz
// module chunks = 11